import { render, staticRenderFns } from "./DoctorMaintain.vue?vue&type=template&id=4a5e5250&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./DoctorMaintain.vue?vue&type=script&lang=js"
export * from "./DoctorMaintain.vue?vue&type=script&lang=js"
import style0 from "./DoctorMaintain.vue?vue&type=style&index=0&id=4a5e5250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5e5250",
  null
  
)

export default component.exports